module.exports = __webpack_public_path__ + "img/ic_fluent_data_bar_vertical_20_regular.ec852ee4.svg";